import React, { useState, useEffect, useRef } from 'react'
import Popup from 'reactjs-popup'
import MobileModal from 'srcReact/components/common2/MobileModal'
import CreateFeedMobile from 'srcReact/components/common2/NewFeed/components/CreateFeedMobile'
import CreateFeedDesktop from 'srcReact/components/common2/NewFeed/components/CreateFeedDesktop'
import { useDispatch, useSelector } from 'react-redux'
import { commonActions } from 'srcReact/components/actions'
import { useTranslation } from 'react-i18next'
import { proceesImagesWithIK, separateFilesByType } from 'srcReact/helpers/fileHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'

function PostFeedModal({
  newsfeedId,
  objectId,
  objectName,
  objectType,
  isEditMode,
  existingFeed, // applicable in case of  draft or edit mode// if draft, it will contain only message property
  objectPicture,
  objectGroupId,
  isModalOpen,
  closeModal,
  showSuccessBanner,
  enableDraft = true,
  showGroupInfoBanner = false,
  originMessageId,
  sharedImageDataUrls,
  sharedImagesToUpload,
  setSharedImageDataUrls,
  setSharedImagesToUpload,
  sharedText,
  setSharedText,
  handleShowNewsFeedPopup,
  messageType,
  commentToUser,
  userToTag,
  post,
  filesFromOuterSelection,
  setReplyOrCommentSent,
  sharedTag
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [inputError, setInputError] = useState('')
  const [posted, setPosted] = useState(false)
  const [sendTriggered, setSendTriggered] = useState(false)
  const [focusedMode, setFocusedMode] = useState(true)
  const [filesToUpload, setFilesToUpload] = useState(filesFromOuterSelection)
  const [finalFiles, setFinalFiles] = useState([])
  const [fileTuple, setFileTuple] = useState([[], []])
  const [content, setContent] = useState({
    name: 'feedContent',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const userTyping = useRef(false)
  const messageSentRef = useRef(false)

  const {
    login: { user: loggedInUser },
    commonNewsfeed: {
      feeds,
      feedTags: { loading: tagsLoading, tags },
      sharedTags: { files }, // Sharing tag files from a native app
      createEditFeed,
      newsFeedType,
      draftMessages,
      organizationId,
      workplaceIds,
      newsFeedList: { selected: selectedNewsFeed }
    },
    common: { isMobile, isTablet, isNative, tagUsersList, filesCreation }
  } = useSelector((state) => state)
  const contentStyle = {
    borderRadius: '0.625rem',
    padding: '1.5rem 1rem 2.5rem',
    background: '#fff',
    overflow: 'auto',
    boxShadow: '0 2px 6px 1px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  }

  const customDesktopStyle = {
    maxHeight: '95vh',
    // height: '30.938rem',
    maxWidth: '41.3rem',
    width: '100%'
  }
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    if (filesFromOuterSelection?.length > 0) {
      setFilesToUpload(filesFromOuterSelection)
    }
  }, [filesFromOuterSelection])

  useEffect(() => {
    if (files?.length > 0) {
      dispatch(
        commonFeedActions.postFeed(
          newsfeedId,
          content.value,
          originMessageId,
          files.toString(),
          getCurrentQuantity(),
          organizationId,
          workplaceIds,
          true
        )
      )
      setTimeout(() => {
        dispatch(commonFeedActions.removeSharingProcessedTagFiles())
        handleCloseModal()
      }, 100)
    }
  }, [files])

  // Save draft message
  useEffect(() => {
    if (enableDraft && !isEditMode) {
      //if send button(with ref) is clicked, do not call this code
      if (content && content.value.length === 0 && userTyping.current && !messageSentRef.current) {
        if (
          (focusedMode &&
            content.value !==
              (draftMessages &&
                draftMessages[newsfeedId] &&
                draftMessages[newsfeedId][originMessageId] &&
                draftMessages[newsfeedId][originMessageId].message)) ||
          (focusedMode &&
            content.value !==
              (draftMessages && draftMessages[originMessageId] && draftMessages[originMessageId].message))
        ) {
          if (
            focusedMode &&
            content.value !== (draftMessages && draftMessages[newsfeedId] && draftMessages[newsfeedId].message)
          ) {
            dispatch(commonFeedActions.addDraftNewsFeed(newsfeedId, originMessageId, content.value))
            dispatch(commonFeedActions.saveDraftToState(content.value, newsfeedId, originMessageId || 0)) //originMessageId || 0 -> 0 is for new post and origin messageId in case of comments
          }
        }
      }
      const draftTimer = setTimeout(() => {
        //if send button(with ref) is clicked, do not call this code
        if (content && content.value && content.value.length > 0 && userTyping.current && !messageSentRef.current) {
          if (
            (focusedMode &&
              content.value !==
                (draftMessages &&
                  draftMessages[newsfeedId] &&
                  draftMessages[newsfeedId][originMessageId] &&
                  draftMessages[newsfeedId][originMessageId].message)) ||
            (focusedMode &&
              content.value !==
                (draftMessages && draftMessages[originMessageId] && draftMessages[originMessageId].message))
          ) {
            if (
              focusedMode &&
              content.value !== (draftMessages && draftMessages[newsfeedId] && draftMessages[newsfeedId].message)
            ) {
              dispatch(commonFeedActions.addDraftNewsFeed(newsfeedId, originMessageId, content.value))
              dispatch(commonFeedActions.saveDraftToState(content.value, newsfeedId, originMessageId || 0)) //originMessageId || 0 -> if 0 is for new post and origin messageId in case of comments
            }
          }
        }
      }, appConstantSettings.SAVE_DRAFT_MESSAGE_TIMOUT)
      return () => clearTimeout(draftTimer)
    }
  }, [content && content.value])

  useEffect(() => {
    if (!tagsLoading && tags?.length > 0 && fileTuple?.length > 0 && sendTriggered) {
      for (const tag of tags) {
        if (fileTuple[0].length > 0) {
          //if there are images
          proceesImagesWithIK(fileTuple[0], tag)
        }
        //if there are documents
        if (fileTuple[1].length > 0) {
          let startingTagIndex = 1
          if (fileTuple[0].length > 0) {
            //if there are images in post, then tag index for document will be after count of images
            startingTagIndex = startingTagIndex + fileTuple[0].length
          }
          dispatch(
            commonActions.complexFilesCreation(fileTuple[1], tag, 1, 'document,compressed_file', startingTagIndex)
          )
        }
        dispatch(commonFeedActions.removeProcessedtag(tag))
      }
      setFinalFiles([])
      setContent({
        ...content,
        value: ''
      })
      setSendTriggered(false)
      setPosted(true)
      setTimeout(() => {
        dispatch(commonFeedActions.updateTagCount())
        handleCloseModal()
      }, 100)
    }
  }, [tagsLoading, tags, sendTriggered])

  useEffect(() => {
    //if message is a plain text with file, show the animation of posted
    if (!createEditFeed.loading && createEditFeed.success && sendTriggered) {
      setSendTriggered(false)
      setPosted(true)

      setTimeout(() => {
        handleCloseModal()
      }, 1000)
    }
  }, [createEditFeed.loading, createEditFeed.success])

  const handleCloseModal = () => {
    // setPosted(false)
    closeModal()
  }

  const getFileError = (fileError) => {
    setInputError(fileError)
  }

  const handleFiles = (newFiles) => {
    setFinalFiles(newFiles)
  }

  const handleChange = (textContent) => {
    setContent({
      ...content,
      value: textContent,
      errorMessage:
        textContent.length === 0 && !sendTriggered
          ? t('error.required', { field: t(`formlabel.${content.name}`) })
          : '',
      hasError: textContent.length === 0
    })
    userTyping.current = true
  }

  const handleFocus = () => {
    setFocusedMode(true)
  }

  //https://github.com/facebook/react/issues/4210
  const handleBlur = (e) => {
    setTimeout(() => setFocusedMode(false), 300)
  }

  const handleErrorFromInputArea = (error) => {
    if (error) {
      setContent({
        ...content,
        hasError: true,
        errorMessage: error
      })
    } else {
      setContent({
        ...content,
        hasError: false,
        errorMessage: ''
      })
    }
  }

  const cancelPost = () => {
    setContent({
      ...content,
      value: ''
    })
    userTyping.current = false
    setFocusedMode(true)
    handleCloseModal()
  }

  const getCurrentQuantity = () => {
    return feeds?.stats?.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : feeds?.stats?.nextOffset
  }
  const callPostMessage = () => {
    if (isEditMode && existingFeed) {
      dispatch(
        commonFeedActions.editFeed(existingFeed.id, content.value, getCurrentQuantity(), organizationId, workplaceIds)
      )
    } else {
      if (setReplyOrCommentSent) {
        setReplyOrCommentSent({ feedId: originMessageId, sent: true })
      }

      dispatch(
        commonFeedActions.postFeed(
          newsfeedId,
          content.value,
          originMessageId,
          '',
          getCurrentQuantity(),
          organizationId,
          workplaceIds,
          false
        )
      )
    }
  }

  const uploadImageCallBack = async (files) => {
    if (files.length > 0) {
      if (files.length <= appConstantSettings.FILES_LIMIT) {
        setFilesToUpload(files)
        setInputError('')
      } else {
        getFileError(t('messenger.clientErrors.maxFiles', { filesLimit }))
      }
    }
  }

  const sendMessage = async () => {
    if (sharedTag && sharedImagesToUpload?.length > 0) {
      dispatch(commonFeedActions.getSharingTagFiles(sharedTag))
    } else if (finalFiles?.length > 0) {
      try {
        const [images, documents] = separateFilesByType(finalFiles)
        setFileTuple([images, documents])
        dispatch(
          commonFeedActions.createBackgroundTag(
            newsfeedId,
            images.length,
            documents.length,
            originMessageId,
            content.value
          )
        )
      } catch (error) {
        dispatch(commonActions.startStopFileProcessing('stop'))
        setInputError(error?.message)
      }
    } else if (content.value.length > 0) {
      callPostMessage()
    } else if (content.value.length === 0) {
      setInputError(t('error.required', { field: t(`formlabel.feedContent`) }))
    }
  }

  const handleSendMessage = () => {
    if (!sendTriggered) {
      messageSentRef.current = true
      setSendTriggered(true)
      sendMessage()
    }
  }

  return (
    <React.Fragment>
      {isMobile || isTablet ? (
        <MobileModal
          isOpen={isModalOpen}
          handleClose={handleCloseModal}
          className='createPostMobile'
          lockScroll
          customContentStyle={{
            height: isNative ? '95vh' : 'calc(100vh - 95px)'
          }}>
          <CreateFeedMobile
            isEditMode={isEditMode}
            content={content}
            posted={posted}
            closeModal={handleCloseModal}
            // sendMessage={sendMessage}
            loadingSendMessage={createEditFeed.loading || tagsLoading}
            filesToUpload={filesToUpload}
            existingContent={existingFeed?.message}
            handleFiles={handleFiles}
            uploadImageCallBack={uploadImageCallBack}
            messageType={messageType}
            commentToUser={commentToUser}
            userToTag={!sendTriggered && !posted ? userToTag : null} //once send is triggered or post api succeed, make userToTag as null//1206390645427630
            post={post}
            entity={
              newsFeedType === 'organization' && !isEditMode && messageType !== 'comment' && messageType !== 'reply'
                ? {
                    type: selectedNewsFeed?.type,
                    id: selectedNewsFeed?.typeId,
                    name: selectedNewsFeed?.name,
                    picture: selectedNewsFeed?.picture
                  }
                : { type: objectType, id: objectId, name: objectName, picture: objectPicture, groupId: objectGroupId }
            }
            getFileError={getFileError}
            error={inputError}
            isGeneral={newsFeedType !== 'group' && newsFeedType !== 'mixr'}
            handleSendMessage={handleSendMessage}
            handleChange={handleChange}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            focusedMode={focusedMode}
            handleErrorFromInputArea={handleErrorFromInputArea}
            showGroupInfoBanner={showGroupInfoBanner}
            draftMessages={draftMessages}
            newsFeedId={newsfeedId}
            originMessageId={originMessageId}
            sharedImageDataUrls={sharedImageDataUrls}
            sharedImagesToUpload={sharedImagesToUpload}
            setSharedImageDataUrls={setSharedImageDataUrls}
            setSharedImagesToUpload={setSharedImagesToUpload}
            handleShowNewsFeedPopup={handleShowNewsFeedPopup}
          />
        </MobileModal>
      ) : (
        <Popup
          open={isModalOpen}
          contentStyle={{ ...contentStyle, ...customDesktopStyle }}
          onClose={handleCloseModal}
          lockScroll
          className='createPost'
          closeOnDocumentClick={false}>
          <CreateFeedDesktop
            content={content}
            messageType={messageType}
            posted={posted}
            isEditMode={isEditMode}
            newsFeedId={newsfeedId}
            existingContent={existingFeed?.message}
            userId={loggedInUser.id}
            userProfilePicture={loggedInUser.profile_picture}
            mimeType={loggedInUser.mime_type}
            originalTag={loggedInUser.original_tag}
            isOriginal={loggedInUser.is_original}
            closeModal={handleCloseModal}
            // sendMessage={sendMessage}
            loadingSendMessage={createEditFeed.loading || tagsLoading}
            filesToUpload={filesToUpload}
            handleFiles={handleFiles}
            activeUsers={tagUsersList}
            uploadImageCallBack={uploadImageCallBack}
            entity={
              newsFeedType === 'organization' && !isEditMode
                ? {
                    type: selectedNewsFeed?.type,
                    id: selectedNewsFeed?.typeId,
                    name: selectedNewsFeed?.name,
                    picture: selectedNewsFeed?.picture
                  }
                : { type: objectType, id: objectId, name: objectName, picture: objectPicture, groupId: objectGroupId }
            }
            getFileError={getFileError}
            error={inputError}
            isGeneral={newsFeedType !== 'group' && newsFeedType !== 'mixr'}
            handleSendMessage={handleSendMessage}
            handleChange={handleChange}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            loggedInUser={loggedInUser}
            focusedMode={focusedMode}
            handleErrorFromInputArea={handleErrorFromInputArea}
            cancelPost={cancelPost}
            originMessageId={originMessageId}
            showGroupInfoBanner={showGroupInfoBanner}
            draftMessages={draftMessages}
            handleShowNewsFeedPopup={handleShowNewsFeedPopup}
          />
        </Popup>
      )}
    </React.Fragment>
  )
}

export default PostFeedModal
